import custom4 from 'theSource/assets/HomeTiles/custom_4.jpeg';
import custom5 from 'theSource/assets/HomeTiles/custom_5.jpeg';
import custom6 from 'theSource/assets/HomeTiles/custom_6.jpeg';
import custom7 from 'theSource/assets/HomeTiles/custom_7.jpeg';
import custom8 from 'theSource/assets/HomeTiles/custom_8.jpeg';
import custom10 from 'theSource/assets/HomeTiles/custom_10.jpeg';
import custom11 from 'theSource/assets/HomeTiles/custom_11.jpeg';
import custom12 from 'theSource/assets/HomeTiles/custom_12.jpg';
import custom13 from 'theSource/assets/HomeTiles/custom_13.jpg';
import custom14 from 'theSource/assets/HomeTiles/custom_14.jpg';
import custom15 from 'theSource/assets/HomeTiles/custom_15.jpg';
import custom16 from 'theSource/assets/HomeTiles/custom_16.jpg';
import custom17 from 'theSource/assets/HomeTiles/custom_17.jpg';
import custom18 from 'theSource/assets/HomeTiles/custom_18.jpg';
import custom19 from 'theSource/assets/HomeTiles/custom_19.jpg';
import custom20 from 'theSource/assets/HomeTiles/custom_20.jpg';
import custom21 from 'theSource/assets/HomeTiles/custom_21.jpg';
import custom22 from 'theSource/assets/HomeTiles/custom_22.jpg';
import custom23 from 'theSource/assets/HomeTiles/custom_23.jpg';
import custom24 from 'theSource/assets/HomeTiles/custom_24.jpg';
import custom25 from 'theSource/assets/HomeTiles/custom_25.jpg';
import custom26 from 'theSource/assets/HomeTiles/custom_26.jpg';
import custom27 from 'theSource/assets/HomeTiles/custom_27.jpg';
import myBenefits from 'theSource/assets/HomeTiles/myBenefits.jpg';
import myCompany from 'theSource/assets/HomeTiles/myCompany.jpg';
import myInbox from 'theSource/assets/HomeTiles/myInbox.jpg';
import myPaycheck from 'theSource/assets/HomeTiles/myPaycheck.jpg';
import healthWealth from 'theSource/assets/HomeTiles/healthWealth.jpg';
import { TileModel, TileDto } from '../types';
import { TILES } from './constants';

export const mapTiles = (
  tiles: TileDto[]
): TileModel[] => {
  const mappedTiles = tiles.map((tile) => ({
    title: tile.title,
    path: tile.external_link,
    lookupCode: tile.lookup_code,
    image_lookup_code: tile.image_lookup_code,
  }));

  mappedTiles.forEach((mappedTile) => {
    const tileIndex = TILES.findIndex(
      (tile) => tile.lookupCode === mappedTile.lookupCode
    );
    if (tileIndex !== -1) {
      if (mappedTile.path !== null && mappedTile.path !== '') {
        TILES[tileIndex].path = mappedTile.path;
      }
      if (mappedTile.title !== null && mappedTile.title !== '') {
        TILES[tileIndex].label = mappedTile.title;
      }
      TILES[tileIndex].backgroundImage = findMappedImage(
        mappedTile.image_lookup_code
      );
    }
  });

  return TILES;
};

const findMappedImage = (imageLookupCode: string) => {
  switch (imageLookupCode) {
    case 'custom_0':
      return myBenefits;
    case 'custom_1':
      return myCompany;
    case 'custom_2':
      return myInbox;
    case 'custom_3':
      return myPaycheck;
    case 'custom_4':
      return custom4;
    case 'custom_5':
      return custom5;
    case 'custom_6':
      return custom6;
    case 'custom_7':
      return custom7;
    case 'custom_8':
      return custom8;
    case 'custom_9':
      return healthWealth;
    case 'custom_10':
      return custom10;
    case 'custom_11':
      return custom11;
    case 'custom_12':
      return custom12;
    case 'custom_13':
      return custom13;
    case 'custom_14':
      return custom14;
    case 'custom_15':
      return custom15;
    case 'custom_16':
      return custom16;
    case 'custom_17':
      return custom17;
    case 'custom_18':
      return custom18;
    case 'custom_19':
      return custom19;
    case 'custom_20':
      return custom20;
    case 'custom_21':
      return custom21;
    case 'custom_22':
      return custom22;
    case 'custom_23':
      return custom23;
    case 'custom_24':
      return custom24;
    case 'custom_25':
      return custom25;
    case 'custom_26':
      return custom26;
    case 'custom_27':
      return custom27;
    default:
      return '';
  }
};
